/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 领券中心，查询用户可领的所有优惠券
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetCentreCouponsParams {
  constructor(public page: number, public size: number) {}
}

export default async function (
  params: GetCentreCouponsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.ProductCouponDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/coupons/centre`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
